import { observable, action, toJS } from 'mobx'
import Api from '@api/xiao_xiong/paymentOrder'
import api from '@api/hua_man'
import { message } from 'hljd'

class Store {
  /**
   * 协议模态框 start
   */
  @observable protocolModalShow = false
  @observable protocolTitle = ''
  @observable protocolContent = ''
  @action
  toggleProtocolModal = (title, content) => {
    this.protocolModalShow = !this.protocolModalShow
    if (this.protocolModalShow) {
      this.protocolTitle = title || ''
      this.protocolContent = content || ''
    }
  }
  @action
  showProtocolModal = (title, content) => () => {
    this.toggleProtocolModal(title, content)
  }
  @action
  setProtocolModal = () => {
    this.protocolTitle = ''
    this.protocolContent = ''
  }
  /**
   * 协议模态框 end
   */

  @observable protocol_checked = true
  @action
  checkChange = e => {
    this.protocol_checked = e.target.checked
  }

  /**
   * 获取订单详情
   */
  id //订单id
  @observable details = {}
  @action
  getDetail = async () => {
    const { data = {}, success } = await Api.getDetailApi({ id: this.id })
    if (success) {
      this.details = data
    }
  }
  /**
   * 到支付頁面
   */
  @action
  goPay = (price, id, trade_no) => () => {
    if (!id || !trade_no || !price) {
      return
    }

    let payType = 2
    if (Number(price) <= 0) {
      payType = 1 // 小于0余额支付
    }
    window.location.href = `#/localMerchant/cashierOrder?payType=${payType}&price=${price}&order_id=${id}&trade_no=${trade_no}&return_url=/localMerchant/marketingCenter/paymentDetail?id=${id}`
  }

  /**
   * 套餐设置
   */
  @observable packageSettingModalVisible = false
  @observable currentItem = {}
  @action
  toggleSettingModal = async (item = {}, type) => {
    this.packageSettingModalVisible = !this.packageSettingModalVisible
    if (this.packageSettingModalVisible) {
      this.currentItem = item
      await this.getPackageDetail()
    }
    if (type == 'save') {
      this.setPackage()
    }
  }

  /**
   * 获取套餐排期详情
   */
  @observable
  currentPacakgeDetail = {
    elements: [],
    scheduleBegin: new Date().toLocaleDateString().replace(/\//g, '-')
  }
  @action
  getPackageDetail = async () => {
    this.mealIDs = []
    const { data } = await api.getPackageDetail({
      productId: this.currentItem.id
    })
    if (!data.scheduleBegin) {
      data.scheduleBegin = new Date().toLocaleDateString().replace(/\//g, '-')
    }
    if (!data.elements || data.elements.length == 0) {
      data.elements = []
    }
    for (let item of data.elements) {
      if (!item.setMeal) {
        item.setMeal = {
          publishedTime: ''
        }
      }
    }
    this.currentPacakgeDetail = data
    for (let i = 0, len = 3; i < len; i++) {
      if (!toJS(this.currentPacakgeDetail.elements[i])) {
        this.currentPacakgeDetail.elements.push({
          id: '',
          coverPath: '',
          title: '',
          publishedAt: '',
          setMeal: {
            publishedTime: ''
          }
        })
      }
      if (
        toJS(this.mealIDs).indexOf(
          toJS(this.currentPacakgeDetail.elements[i]).setMeal.id
        ) < 0
      ) {
        this.mealIDs.push(
          Number(toJS(this.currentPacakgeDetail.elements[i]).setMeal.id)
        )
      }
    }
    this.mealIDs = toJS(this.mealIDs).filter(id => !!id)
  }

  /**
   * 创意中心弹窗
   */
  @observable materialModalVisible = false
  @action
  toggleMaterialModal = e => {
    if (e.target.tagName != 'I') {
      this.materialModalVisible = !this.materialModalVisible
      if (this.materialModalVisible) {
        this.param.page = 1
        this.getMaterialList()
      } else {
        for (let item of this.materialList) {
          item.active = false
        }
      }
    }
  }

  @observable materialList = []
  @observable
  param = {
    page: 1,
    pageSize: 8,
    total: 0
  }
  @action
  getMaterialList = async () => {
    const params = {
      page: this.param.page,
      per_page: this.param.pageSize,
      status: 1,
      type: 4
    }
    const {
      success,
      data: { list, total_count }
    } = await api.getMaterialList(params)
    if (success) {
      for (let id of toJS(this.mealIDs)) {
        for (let item of list) {
          if (item.detail.set_meals_data.id == id) {
            item.active = true
          }
        }
      }
      this.materialList = list
      this.param.total = total_count
    }
  }

  @observable mealIDs = []
  @action
  togglePackageCheck = (id, index) => () => {
    const idIndex = toJS(this.mealIDs).indexOf(Number(id))
    const materialList = toJS(this.materialList)
    materialList[index].active = !materialList[index].active
    if (materialList[index].active) {
      if (this.mealIDs.length < 3) {
        this.mealIDs.push(Number(materialList[index].detail.set_meals_data.id))
      } else {
        message.warning('最多只能选择3个套餐')
        return false
      }
    } else {
      this.mealIDs.splice(idIndex, 1)
    }
    this.materialList = materialList
  }

  @action
  setPackage = async () => {
    const params = {
      scheduleId: this.currentPacakgeDetail.id,
      setMealIds: toJS(this.mealIDs)
    }
    const res = await api.setPackage(params)
    console.log(res)
    this.materialModalVisible = false
    this.getDetail()
    this.getPackageDetail()
  }

  @action
  deletePackage = index => () => {
    const elements = toJS(this.currentPacakgeDetail.elements)
    elements.splice(index, 1, {
      id: '',
      coverPath: '',
      title: '',
      publishedAt: '',
      setMeal: {
        publishedTime: ''
      }
    })
    this.mealIDs = elements
      .filter(item => !!item.id)
      .map(item => item.setMeal.id)
    this.currentPacakgeDetail.elements = elements
  }

  @action
  handleMaterialPagination = page => {
    this.param.page = page
    this.getMaterialList()
  }
}

export default new Store()
